/**
 * User Form Component Types
 */

import { z } from 'zod';

/**
 * User Form Validation Schema with Zod
 */
export const userFormSchema = z.object({
  firstName: z
    .string()
    .min(1, 'Nome é obrigatório')
    .min(2, 'Nome deve ter no mínimo 2 caracteres')
    .max(100, 'Nome deve ter no máximo 100 caracteres'),
  
  lastName: z
    .string()
    .min(1, 'Sobrenome é obrigatório')
    .min(2, 'Sobrenome deve ter no mínimo 2 caracteres')
    .max(100, 'Sobrenome deve ter no máximo 100 caracteres'),
  
  email: z
    .string()
    .min(1, 'Email é obrigatório')
    .email('Email inválido'),
  
  password: z
    .string()
    .optional()
    .refine((val) => !val || val.length >= 6, {
      message: 'Senha deve ter no mínimo 6 caracteres',
    }),
  
  organizationId: z
    .number({
      required_error: 'Selecione uma organização',
      invalid_type_error: 'Selecione uma organização válida',
    })
    .int('Organização inválida')
    .positive('Selecione uma organização'),
  
  status: z.enum(['active', 'inactive', 'blocked'], {
    errorMap: () => ({ message: 'Status inválido' }),
  }),
});

/**
 * Create mode schema (password required)
 */
export const userFormCreateSchema = userFormSchema.extend({
  password: z
    .string()
    .min(1, 'Senha é obrigatória')
    .min(6, 'Senha deve ter no mínimo 6 caracteres'),
});

/**
 * Infer TypeScript type from schema
 */
export type UserFormData = z.infer<typeof userFormSchema>;

export interface UserFormProps {
  /**
   * Initial form values for editing
   */
  initialValues?: Partial<UserFormData>;

  /**
   * Form mode
   */
  mode: 'create' | 'edit';

  /**
   * Submit callback
   */
  onSubmit: (data: UserFormData) => void | Promise<void>;

  /**
   * Cancel callback
   */
  onCancel: () => void;

  /**
   * Loading state
   */
  isLoading?: boolean;
}
